<template>
  <stickyelement class="tags-sticky">
    <div class="tags-section">
      <ul ref="tagsList" class="tags-section--list">
        <span id="tabletview">
          <template v-for="(tag, index) in articleDataset.tags">
            <li
              v-if="index < limitBytab"
              :key="tag.id"
              :class="{ 'is-tag-disabled': tag.disabled, 'is-tag-selected': tag.selected }"
            >
              <label :for="tag.id + 'tabletview'">
                <input
                  :id="tag.id + 'tabletview'"
                  :disabled="tag.disabled"
                  :checked="tag.selected"
                  type="checkbox"
                  @change="filterArticles(tag, tag.url_to_show)"
                />
                <span>{{ tag.title }} <em class="checkmark"></em></span>
              </label>
            </li>
          </template>
        </span>
        <span id="tabletview_pro">
          <template v-for="(tag, index) in articleDataset.tags">
            <li
              v-if="index < limitBytabpro"
              :key="tag.id"
              :class="{ 'is-tag-disabled': tag.disabled, 'is-tag-selected': tag.selected }"
            >
              <label :for="tag.id + 'tabletview_pro'">
                <input
                  :id="tag.id + 'tabletview_pro'"
                  :disabled="tag.disabled"
                  :checked="tag.selected"
                  type="checkbox"
                  @change="filterArticles(tag, tag.url_to_show)"
                />
                <span>{{ tag.title }} <em class="checkmark"></em></span>
              </label>
            </li>
          </template>
        </span>
        <span id="desktopview">
          <li
            v-for="tag in articleDataset.tags"
            :key="tag.id"
            :class="{ 'is-tag-disabled': tag.disabled, 'is-tag-selected': tag.selected }"
          >
            <label :for="tag.id + 'desktopview'">
              <input
                :id="tag.id + 'desktopview'"
                :disabled="tag.disabled"
                :checked="tag.selected"
                type="checkbox"
                @change="filterArticles(tag, tag.url_to_show)"
              />
              <span>{{ tag.title }} <em class="checkmark"></em></span>
            </label>
          </li>
        </span>
        <span id="mobileview">
          <template v-for="(tag, index) in articleDataset.tags">
            <li
              v-if="index < limitBy"
              :key="tag.id"
              :class="{ 'is-tag-disabled': tag.disabled, 'is-tag-selected': tag.selected }"
            >
              <label :for="tag.id + 'mobileview'">
                <input
                  :id="tag.id + 'mobileview'"
                  :disabled="tag.disabled"
                  :checked="tag.selected"
                  type="checkbox"
                  @change="filterArticles(tag, tag.url_to_show)"
                />
                <span>{{ tag.title }} <em class="checkmark"></em></span>
              </label>
            </li>
          </template>
        </span>
        <li class="tags-section-clear">
          <a
            v-if="articleDataset.show_clear_filters"
            href="#"
            class="tags-href-clear"
            @click.prevent="
              filterArticles(articleDataset.clear_filter_api_url, articleDataset.clear_filter_url)
            "
          >
            {{ articleDataset.filter_data.clear_filters }}
          </a>
          <a
            id="mobileview"
            href="javascript:void(0)"
            style="float: right; text-decoration: underline"
            :aria-label="ariaLabelMobile"
            @click="simple_toggle(defaultLimit, articleDataset.tags.length)"
            >{{ tagname }}</a
          >
          <a
            id="tabletview"
            href="javascript:void(0)"
            style="float: right; text-decoration: underline"
            :aria-label="ariaLabelTablet"
            @click="simple_toggle_tab(defaultLimittab, articleDataset.tags.length)"
            >{{ tagnameTab }}</a
          >
          <a
            id="tabletview_pro"
            href="javascript:void(0)"
            style="float: right; text-decoration: underline"
            :aria-label="ariaLabelTabletPro"
            @click="simple_toggle_tab_pro(defaultLimittabpro, articleDataset.tags.length)"
            >{{ tagnameTabpro }}</a
          >
        </li>
      </ul>
      <loadingoverlay></loadingoverlay>
    </div>
  </stickyelement>
</template>
<script>
export default {
  name: 'tags',
  props: {
    articleDataset: { type: Object, required: true },
    ariaLabelMobile: {
      type: String,
      default: '',
    },
    ariaLabelTablet: {
      type: String,
      default: '',
    },
    ariaLabelTabletPro: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      limitBy: 5,
      limitBytab: 10,
      defaultLimit: 5,
      defaultLimittab: 10,
      limitBytabpro: 16,
      defaultLimittabpro: 16,
      tagnameTabpro: this.articleDataset.filter_data.show_more_tags,
      tagnameTab: this.articleDataset.filter_data.show_more_tags,
      tagname: this.articleDataset.filter_data.show_more_tags,
      width: 1000,
      min: 700,
      max: 1000,
      smallScreen: window.ScreenSizeHandler
        ? !window.ScreenSizeHandler.getMqForSize('small').selected
        : true,
    };
  },
  mounted() {
    this.$nextTick(this.calculateWidth);
  },
  methods: {
    selectChangetags(tags) {
      if (tags && tags.selected) {
        dataLayer.push({
          event: 'uaevent',
          event_name: 'use_filters',
          ecommerce: 'undefined',
          eventCategory: 'content page::article',
          eventAction: 'filter',
          eventLabel: `${tags.title.toLowerCase()}` || 'none',
          filter_type: 'filter',
          filter_value: `${tags.title.toLowerCase()}` || 'none',
        });
      }
    },
    filterArticles(apiUrl, pushState = false) {
      /// TAGGING-Filters
      if (Object.keys(apiUrl).length > 0 && apiUrl.constructor === Object) {
        this.$parent.getData(apiUrl.url_to_api_with_params, pushState);
        if (apiUrl && apiUrl.title) {
          dataLayer.push({
            event: 'uaevent',
            event_name: 'use_filters',
            ecommerce: 'undefined',
            eventCategory: 'content page::article',
            eventAction: 'filter',
            eventLabel: `${apiUrl.title.toLowerCase()}` || 'none',
            filter_type: 'filter',
            filter_value: `${apiUrl.title.toLowerCase()}` || 'none',
          });
        }
      } else {
        this.$parent.getData(apiUrl, pushState);
      }
    },
    simple_toggle(defaultLimit, filtersLength) {
      this.limitBy = this.limitBy === defaultLimit ? filtersLength : defaultLimit;
      if (this.limitBy === defaultLimit) {
        window.scrollTo(0, 50);
        this.tagname = this.articleDataset.filter_data.show_more_tags;
      } else {
        window.scrollTo(0, 0);
        this.tagname = this.articleDataset.filter_data.show_less_tags;
      }
    },
    simple_toggle_tab(defaultLimittab, filtersLengthTab) {
      this.limitBytab = this.limitBytab === defaultLimittab ? filtersLengthTab : defaultLimittab;
      if (this.limitBytab === defaultLimittab) {
        window.scrollTo(0, 50);
        this.tagnameTab = this.articleDataset.filter_data.show_more_tags;
      } else {
        window.scrollTo(0, 0);
        this.tagnameTab = this.articleDataset.filter_data.show_less_tags;
      }
    },
    simple_toggle_tab_pro(defaultLimittabpro, filtersLengthTabPro) {
      this.limitBytabpro =
        this.limitBytabpro === defaultLimittabpro ? filtersLengthTabPro : defaultLimittabpro;
      if (this.limitBytabpro === defaultLimittabpro) {
        window.scrollTo(0, 50);
        this.tagnameTabpro = this.articleDataset.filter_data.show_more_tags;
      } else {
        window.scrollTo(0, 0);
        this.tagnameTabpro = this.articleDataset.filter_data.show_less_tags;
      }
    },
    calculateWidth() {
      if (this.$refs.tagsList) {
        const nodeList = this.$refs.tagsList.querySelectorAll('li:not(.tags-href-clear)');
        let width = 0;

        Array.prototype.forEach.call(nodeList, (item) => {
          width += this.outerWidth(item);
        });
          this.width = this.formatForCss(Math.min(Math.max((width / 2), this.min), this.max)) // eslint-disable-line
      }
    },
    outerWidth(el) {
      let width = el.offsetWidth;
      const style = window.getComputedStyle(el);
      width += (parseInt(style.marginLeft, 10) || 0) + (parseInt(style.marginRight, 10) || 0);
      return width;
    },
    formatForCss(width) {
      return `${width}px`;
    },
  },
};
</script>
